import type { IconData } from '@stacksjs/iconify-core'

export const cameraF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.126 3C4.57 1.275 6.136 0 8 0h4a4 4 0 0 1 3.874 3H16a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zM10 13a4 4 0 1 0 0-8a4 4 0 0 0 0 8m6-5a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-6 3a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cameraF
